import groupBy from 'lodash.groupby';
import { TypeFilterLabel } from '../components/Filters/useFilters';

const getFormattedFilters = (filters: TypeFilterLabel[]): string =>
  Object.entries(groupBy(filters, 'type'))
    .map(([key, labels]) => `${key}:${labels.map(({ value }) => value).join(',')}`)
    .join(';')
    .trim();

export default getFormattedFilters;
